import type { HourSummaryRow } from 'redux/modules/superreports-datatable.types';
import { xhrStatusFactory } from 'redux/reusable/xhrStatus';
import type { Hour } from 'types/hour';
import actionCreatorFactory from 'typescript-fsa';
import type { HourSummaryFilter } from '~types/hours';

const actionCreator = actionCreatorFactory('HOUR_SUMMARY');

export const FETCH_HOUR_SUMMARY_KEY = 'FETCH_HOUR_SUMMARY';
export const FETCH_PROJECT_SUMMARY_KEY = 'FETCH_PROJECT_SUMMARY';

export interface HourSummaryInfo {
  label: string;
  total: number;
  currency_code: string;
  interval_order?: string;
}

export interface HourSummary {
  id: number;
  name: string;
  num_of_projects: number;
  num_of_users: number;
  total: number;
  currency_code: string;
  color: string;
  summary_info: HourSummaryInfo[];
}

export interface State {
  entities: {
    [key: string]: HourSummary;
  };
  result: Array<number>;
  maybeHasMore: boolean;
  totalCount: number;
  xhrStatus: ReturnType<typeof xhrStatusFactory>;
  projectSummaries: {
    [clientId: string]: {
      entities: {
        [key: string]: HourSummary;
      };
      result: Array<number>;
    };
  };
}

export const initialHourSummaryState: State = {
  entities: {},
  result: [],
  maybeHasMore: false,
  totalCount: 0,
  xhrStatus: xhrStatusFactory(),
  projectSummaries: {},
};

// export const fetchedHourSummary = actionCreator<Array<HourSummary>>('FETCHED_HOUR_SUMMARY')

export const fetchedHourSummary = actionCreator<{
  data: Array<HourSummary>;
  append?: boolean;
  maybeHasMore: boolean;
  totalCount: number;
}>('FETCHED_HOUR_SUMMARY');

export const fetchedProjectSummary = actionCreator<{
  clientId: string;
  data: Array<Hour<HourSummaryRow | number>>;
}>('FETCHED_PROJECT_SUMMARY');

export const hourSummaryXhrStatusModule = xhrStatusFactory({});

export const HOUR_SUMMARY_INITIAL_FILTER: HourSummaryFilter = {
  limit: 5,
  page: 1,
  hasMore: false,
  sortBy: {
    field: 'time',
    direction: 'desc',
  },
};
